import * as actionTypes from "../../../actions/actionTypes";
const documents = (state = { dataChanged: false }, action) => {
  switch (action.type) {
    case actionTypes.SET_DOCUMENTS:
      return { ...state, dataChanged: true, ...action.payload };
    default:
      return state;
  }
};

export default documents;
